import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { NavigationPanel } from 'src/domains/layouts/webview/components/navigationPanel/NavigationPanel';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { PopularSportState } from 'src/domains/layouts/state/popularSportState/PopularSportState';

export const RenderPopularSportsAndPromotedEvents = observer('RenderPopularSports', (): JSX.Element | null => {
    const common = useCommon();
    const configComponents = ConfigComponents.get(common).config;
    const popularSportState = PopularSportState.get(common);

    const navigationPopular = configComponents.navigationPopular;
    if (navigationPopular === null) {
        return null;
    }

    const out = popularSportState.generateNavigationList(navigationPopular);
    return (
        <NavigationPanel
            title={
                <I18n
                    langKey='left-menu.popular.title'
                    defaultText='Popular'
                />
            }
            titleDataTest='popular'
            links={out}
            typeTag='sport'
        />
    );
});
